module.exports = __webpack_public_path__ + "static/media/TownPlannerIcon.212c689a.svg";